import { Link } from "react-router-dom";

const ICON_URL =
    "https://customer-assets.emergentagent.com/job_bd924cda-aeef-4b77-b265-df028a44b434/artifacts/1osskqe6_3E5BB8AE-DADE-4A70-A667-D48D088B8602_1.PNG";

export default function Logo({ size = 36, withText = true, asLink = false, className = "", variant = "light" }) {
    const oneColor = variant === "dark" ? "text-white" : "text-[#0A1930]";
    const inner = (
        <span className={`inline-flex items-center gap-2 ${className}`} data-testid="brand-logo">
            <img
                src={ICON_URL}
                width={size}
                height={size}
                alt="OnePassCredit"
                className="rounded-lg"
                style={{ width: size, height: size }}
            />
            {withText && (
                <span className="font-display font-bold tracking-tight text-lg leading-none">
                    <span className={oneColor}>One</span>
                    <span className="text-[#0066FF]">Pass</span>
                    <span className="text-[#00D084]">Credit</span>
                </span>
            )}
        </span>
    );
    if (asLink) return <Link to="/">{inner}</Link>;
    return inner;
}
